import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, formatMoney } from "@/lib/api";
import { Progress } from "@/components/ui/progress";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

export default function FundraiserDetail() {
  const { fid } = useParams();
  const [f, setF] = useState(null);
  const [amount, setAmount] = useState(50);
  const [busy, setBusy] = useState(false);

  useEffect(() => { api.get(`/fundraisers/${fid}`).then(({ data }) => setF(data)); }, [fid]);

  const donate = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/checkout/donation", {
        package_id: "custom", custom_amount: parseFloat(amount),
        fundraiser_id: fid, origin_url: window.location.origin,
      });
      if (data?.url) window.location.href = data.url;
    } catch (e) { toast.error(e?.response?.data?.detail || "Could not donate"); setBusy(false); }
  };

  if (!f) return <div className="max-w-3xl mx-auto px-6 py-16">Loading...</div>;
  const pct = Math.min(100, (f.raised / f.goal_amount) * 100);

  return (
    <div className="max-w-4xl mx-auto px-6 py-10" data-testid="fundraiser-detail-page">
      <div className="card-soft overflow-hidden">
        <img src={f.image_url} alt={f.title} className="w-full aspect-[16/7] object-cover" />
        <div className="p-6">
          <div className="text-xs uppercase tracking-wider text-purple-600 font-bold">{f.category}</div>
          <h1 className="font-display text-3xl md:text-4xl font-bold text-slate-900 mt-2">{f.title}</h1>
          <p className="text-sm text-slate-600 mt-1">Organized by {f.organizer_name}</p>
          <p className="text-slate-700 mt-5 whitespace-pre-wrap">{f.description}</p>
          <Progress value={pct} className="mt-6" />
          <div className="flex justify-between mt-2"><span className="font-bold text-pink-600 text-lg">{formatMoney(f.raised)} raised</span><span className="text-slate-500">of {formatMoney(f.goal_amount)}</span></div>
          <div className="mt-6 flex items-center gap-3 flex-wrap">
            <Input data-testid="fr-donate-amount" type="number" min="5" max="5000" value={amount} onChange={(e) => setAmount(e.target.value)} className="max-w-[160px]" />
            <button data-testid="fr-donate-btn" disabled={busy} onClick={donate} className="btn-pink">{busy ? "Redirecting..." : "Donate Now"}</button>
          </div>
        </div>
      </div>
    </div>
  );
}
